'use strict';

import CaptchaUtil from './util/captchaUtil';

class customerService {
  run() {
    $(document).ready(() => {
      this.customerServiceInputCode();
      this.submitContactUsEvent();
      CaptchaUtil.initialize('contact_form');
    });
  }

  checkProfiling() {
    const profiling = $('#profiling');

    $('#email-signup').on('change', (e) => {
      const self = $(e.currentTarget);

      if (self.is(':checked')) {
        profiling.removeAttr('disabled');
      } else {
        profiling.attr('disabled', 'disabled');

        if (profiling.is(':checked')) {
          profiling.prop('checked', false);
        }
      }
    });
  }

  customerServiceInputCode() {
    var myQuestion = $('#customer-service-arguments').val();
    $('input[name$=myquestion]').val(myQuestion);

    $('#customer-service-arguments').on('change', function () {
      $('input[name$=myquestion]').val($(this).val());
    });
  }

  submitContactUsEvent() {
    $('form.contact-form').submit((e) => {
      var $form = $(e.currentTarget);
      var button = $form.find('.button');
      $(button).attr('disabled', true);
    });
  }
}

const CustomerService = new customerService();
CustomerService.run();



// WEBPACK FOOTER //
// ./assets/scripts/contactus.js